import { LogLevel } from '@azure/msal-browser';
import { ENVIRONMENT, PlatformEnv } from '@evc/platform';

export const baseEnvironment = {
  production: true,
  name: ENVIRONMENT.production,
  logLevel: LogLevel.Error,
  ENV: ENVIRONMENT.production,
  AUTH_CLIENT_ID: 'b72db547-e0bb-43cd-97a5-90354020aefd',
  USE_CONNECT_PLATFORM: true,
  APP_NAME: 'rtb',
  APP_TITLE: 'Report Template Builder',
  APP_LOGO: 'assets/favicon/favicon.svg',
  PROTECTED_URIS: {
    RTB: `${window.location.origin}/api`
  }
} as PlatformEnv & Record<string, any>;
